import React, { useState } from 'react';
import MultiplePetItem from './multiplePets';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import {
    AUTOCOMPLETE_TYPE,
    DIMENSION_UNIT,
    FORM_FIELDS,
    FRESH_FORWARD_PRODUCT,
    getInitLooseItemDetail,
    getInitPharmaObject,
    getInitULDItemDetail,
    PHARMA_PRODUCT,
    PHARMA_SHIPPING_TYPE,
    IS_KNOWN_UNKNOWN,
    PRICE_CODE_TYPE,
    SCC_CODES,
    SHIPPING_TYPE,
    VALIDATE_BOOKINGS_ERROR_CODES,
    WEIGHT_UNIT,
    NOTIFICATION_MESSAGE_TYPE,
    SYSTEM_ADDED_SCCS,
    PAGE_PRIMARY_CATEGORY,
    PAGE_SUB_CATEGORY1,
    getInitPetDetail,
    WEIGHT_UNIT_SELECT_ITEMS,
    DIMENSION_UNIT_SELECT_ITEMS,
    getInitCageDetails,
} from '../../../constants'
import { useEffect } from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { Message } from 'primereact/message';
import Cages from './cages';
import { AlertMessage } from '../AlertMessage';
import errorFilledOrange from '../../../assets/images/errorFilledOrange.svg'
import RadioToggle from '../RadioToggle';
import plusDarkIcon from '../../../assets/images/plusDarkBlue.svg';

const MultiplePetsContainer = ({
    shippingItem,
    // petList,
    // setPetList,
    file,
    setFile,
    dogBreeds,
    searchFormData,
    setArrayListDoc,
    arrayListDoc,
    setCageList,
    cageList,
    setDeletedCageIds,
    deletedCageIds,
    setDeletedPetIds,
    deletedPetIds,
    error,
    setError,
    weightUnit,
    dimensionUnit,
    setDimensionUnit,
    setWeightUnit,
    stubNose,
    setStubNose,
    breedRejected,
    setBreedRejected,
    setTotalPieces
}) => {

    const { t, i18n } = useTranslation(['labels', 'errors'])
    const [petOrder, setPetOrder] = useState(0);

    const handleAddCageItem = () => {
        let cageData = [...cageList, getInitCageDetails(weightUnit, dimensionUnit)]
        cageData[cageData.length - 1].cageOrder = cageData.length - 1
        setCageList(cageData)
    }

    return (
        <>
            <div className='cargo-additional-dg-style-row'>
                <div className='top-section'>
                    <div className='d-flex align-items-center'>
                        <img className='dg-info' src={errorFilledOrange} alt='info' title='dg-info' />
                        <label className='dg-label'>{t('COMMON.IS_SNUB')}</label>
                    </div>
                    <RadioToggle
                        checkedArray={[stubNose, !stubNose]}
                        valueArray={["Yes", "No"]}
                        labelArray={['COMMON.YES', 'COMMON.NO']}
                        className='stubnose-check-toggle'
                        onChangeArray={[() => {
                            setStubNose(true)
                            setTotalPieces(0)
                            setTimeout(() => {
                                setStubNose(false)
                                setPetOrder(0)
                            }, 6500)
                        },
                        () => {
                            setStubNose(false)
                            setPetOrder(0)
                        }]}
                    />
                </div>
            </div>
            <AlertMessage
                type='error'
                message={stubNose && t('COMMON.SNUB_NOSED_NOT_ALLOWED')}
                isPopup
                onClose={() => setStubNose(false)}
            />
            {
                !stubNose &&
                <>
                    <Cages
                        shippingItem={shippingItem}
                        file={file}
                        setFile={setFile}
                        dogBreeds={dogBreeds}
                        searchFormData={searchFormData}
                        setArrayListDoc={setArrayListDoc}
                        arrayListDoc={arrayListDoc}
                        petOrder={petOrder}
                        setCageList={setCageList}
                        cageList={cageList}
                        setDeletedCageIds={setDeletedCageIds}
                        deletedCageIds={deletedCageIds}
                        setDeletedPetIds={setDeletedPetIds}
                        deletedPetIds={deletedPetIds}
                        error={error}
                        setError={setError}
                        weightUnit={weightUnit}
                        dimensionUnit={dimensionUnit}
                        setDimensionUnit={setDimensionUnit}
                        setWeightUnit={setWeightUnit}
                        breedRejected={breedRejected}
                        setBreedRejected={setBreedRejected}
                    />
                    <div className='uld-add-overflow'>
                        <div className='overflow-contents'>
                            <button type='button' className='overflow-button secondary-button' onClick={(e) => handleAddCageItem(e)}>
                                <img className='add-more-plus' src={plusDarkIcon} alt='plus' title='add-more-plus' />
                                {t('COMMON.ADD_ANOTHER_CAGE')}
                            </button>
                        </div>
                    </div>
                </>
            }

        </>
    )
}

export default MultiplePetsContainer;